import FactoryMenu from './FactoryMenu'
export default FactoryMenu
